import { Routes } from '@angular/router';
import { MapComponent } from './components/map/map.component';
import { LoginComponent } from './components/auth/login/login.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { AdminComponent } from './components/admin/admin.component';
import { adminGuard } from './security/admin.guard';
import { ProfileComponent } from './components/profile/profile.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { FavoritesComponent } from './components/favorites/favorites.component';
import { authGuard } from './security/auth.guard';
import { AboutComponent } from './components/about/about.component';
import { ImpressumComponent } from './components/impressum/impressum.component';
import { DatenschutzComponent } from './components/datenschutz/datenschutz.component';
import { SearchResultsComponent } from './components/search/search-results.component';
import { SettingsDetailComponent } from './components/settings-overview/settings-detail/settings-detail.component';
import { SettingsOverviewComponent } from './components/settings-overview/settings-overview.component';
import { TreeComponent } from './components/tree/tree.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'search', component: SearchResultsComponent },
  {
    path: 'favorites',
    component: FavoritesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [adminGuard],
    loadChildren: () => import('./components/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
  { path: 'settings', component: SettingsOverviewComponent },
  { path: 'settings/:id', component: SettingsDetailComponent },
  { path: 'user/:username', component: ProfileComponent },
  { path: 'tree', component: TreeComponent },
  { path: 'ueber-uns', component: AboutComponent },

  { path: 'imprint', component: ImpressumComponent },
  { path: 'impressum', component: ImpressumComponent },

  { path: 'privacy', component: DatenschutzComponent },
  { path: 'datenschutz', component: DatenschutzComponent },

  { path: ':slug', component: MapComponent },
  { path: '', component: MapComponent },
  { path: '**', redirectTo: '' },
];
